import router from "./router"
import NProgress from "nprogress"
import "nprogress/nprogress.css"
import { getData } from "./utils/auth"
import { Dialog } from "vant"

NProgress.configure({showSpinner: false});

router.beforeEach(async (to, from, next) => {

    console.log("===== permission.js 路由守卫开始执行 =====");
    console.log("to.path =", to.path);
    console.log("from.path =", from.path);

    NProgress.start();
    const hasToken = getData();

    console.log("getData() 返回值 =", hasToken);
    console.log("是否被判断为已登录 = ", !!hasToken);

    if (hasToken) {
        if (to.path === "/register") {
            next({path: "/", replace: true});
        } else {
            next();
        }
    } else {
        if (to.path === "/register") {
            NProgress.done();
            next();
        } else {
            NProgress.done();
            Dialog.alert({
                title: "登録していない", //您未登录
                message: "新規登録画面の右上にある「ログイン」から、再度ログインする" //请前往注册页面并点击右上角'立即登录'按钮, 重新登录
            }).then(() => {
                next("/register");
            })
        }
    }
});

router.afterEach(() => {
    NProgress.done();
});